// istanbul ignore file
import { Injectable } from '@angular/core';
import { checkAvailability, cordovaInstance, IonicNativePlugin } from '@ionic-native/core';

export class SecureStorageObject {
  constructor(private _objectInstance: unknown) {}
  get = function (key: string) {
    return cordovaInstance(this, 'get', { callbackOrder: 'reverse' }, arguments);
  };
  set = function (key: string, value: string) {
    return cordovaInstance(this, 'set', { callbackOrder: 'reverse' }, arguments);
  };
  remove = function (key: string) {
    return cordovaInstance(this, 'remove', { callbackOrder: 'reverse' }, arguments);
  };
  keys = function () {
    return cordovaInstance(this, 'keys', { callbackOrder: 'reverse' }, arguments);
  };
  clear = function () {
    return cordovaInstance(this, 'clear', { callbackOrder: 'reverse' }, arguments);
  };
}

@Injectable()
export class SecureStoragePlugin extends IonicNativePlugin {
  static pluginName = 'SecureStoragePlugin';
  static plugin = 'cordova-plugin-secure-storage-echo';
  static pluginRef = 'cordova.plugins.SecureStorage';
  static repo = 'https://github.com/mibrito707/cordova-plugin-secure-storage-echo';
  static platforms = ['Android', 'Browser', 'iOS', 'Windows'];

  private _objectInstance: unknown;

  create(name: string, option?: object): Promise<SecureStorageObject> {
    if (checkAvailability(this)) {
      return new Promise((resolve, reject) => {
        this._objectInstance = new (SecureStoragePlugin.getPlugin())(
          () => resolve(new SecureStorageObject(this._objectInstance)),
          reject,
          name,
          option
        );
      });
    }
  }

  secureDevice = function () {
    if (!this._objectInstance) {
      throw new Error('[SecureStoragePlugin] Please call the create method first!');
    }
    return cordovaInstance(this, 'secureDevice', {}, arguments) as Promise<void>;
  };
}
